import React from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import ColorPickerControl from '../CommonProperties/ColorPickerControl';
import PaddingControl from '../CommonProperties/PaddingControl';
import StyleControl from '../CommonProperties/StyleControl';
import { usePropertyPanel } from '../PropertyPanelContext';
import { useSelector } from 'react-redux';
import { selectSelectedComponent } from '../../../redux/editorSlice';

const SearchBarProperties = () => {
  const selectedComponent = useSelector(selectSelectedComponent);
  const { handleComponentPropsChange } = usePropertyPanel() || {};
  
  // componentProps가 없을 때 기본값 사용
  const componentProps = selectedComponent?.componentProps || {};
  const handlePropsChange = handleComponentPropsChange || (() => {});
  
  const {
    skin = 'basic',
    placeholder = '검색어를 입력하세요',
    buttonText = '검색',
    searchPath = '/searched',
    showIcon = true,
    inputHeight = '45px',
    buttonColor = '#007bff',
    buttonTextColor = '#ffffff',
    borderRadius = '4px',
    fullWidth = true,
    showShadow = true,
    primaryColor = '#007bff',
    className = ''
  } = componentProps;

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>스킨 선택</Form.Label>
        <Form.Select
          value={skin}
          onChange={(e) => handlePropsChange('skin', e.target.value)}
        >
          <option value="basic">기본 스킨</option>
          <option value="modern">모던 스킨</option>
        </Form.Select>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>플레이스홀더 텍스트</Form.Label>
        <Form.Control
          type="text"
          value={placeholder}
          onChange={(e) => handlePropsChange('placeholder', e.target.value)}
          placeholder="검색창 안내 문구"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>버튼 텍스트</Form.Label>
        <Form.Control
          type="text"
          value={buttonText}
          onChange={(e) => handlePropsChange('buttonText', e.target.value)}
          placeholder="검색 버튼 텍스트"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>검색 결과 페이지 경로</Form.Label>
        <Form.Control
          type="text"
          value={searchPath}
          onChange={(e) => handlePropsChange('searchPath', e.target.value)}
          placeholder="/searched"
        />
        <Form.Text className="text-muted">
          검색 시 이동할 페이지 경로 (기본값: /searched)
        </Form.Text>
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>입력창 높이</Form.Label>
        <Form.Control
          type="text"
          value={inputHeight}
          onChange={(e) => handlePropsChange('inputHeight', e.target.value)}
          placeholder="45px"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Label>테두리 둥글기</Form.Label>
        <Form.Control
          type="text"
          value={borderRadius}
          onChange={(e) => handlePropsChange('borderRadius', e.target.value)}
          placeholder="4px"
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="switch"
          label="검색 아이콘 표시"
          checked={showIcon}
          onChange={(e) => handlePropsChange('showIcon', e.target.checked)}
        />
      </Form.Group>

      <Form.Group className="mb-3">
        <Form.Check
          type="switch"
          label="전체 너비 사용"
          checked={fullWidth}
          onChange={(e) => handlePropsChange('fullWidth', e.target.checked)}
        />
      </Form.Group>

      {skin === 'modern' && (
        <Form.Group className="mb-3">
          <Form.Check
            type="switch"
            label="그림자 효과"
            checked={showShadow}
            onChange={(e) => handlePropsChange('showShadow', e.target.checked)}
          />
        </Form.Group>
      )}

      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>주요 색상</Form.Label>
            <ColorPickerControl
              value={primaryColor}
              onChange={(color) => handlePropsChange('primaryColor', color)}
            />
          </Form.Group>
        </Col>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>버튼 색상</Form.Label>
            <ColorPickerControl
              value={buttonColor}
              onChange={(color) => handlePropsChange('buttonColor', color)}
            />
          </Form.Group>
        </Col>
      </Row>
      
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>버튼 텍스트 색상</Form.Label>
            <ColorPickerControl
              value={buttonTextColor}
              onChange={(color) => handlePropsChange('buttonTextColor', color)}
            />
          </Form.Group>
        </Col>
      </Row>
      
      <hr className="my-4" />
      
      {/* 여백 설정 */}
      <PaddingControl />
      
      <hr className="my-4" />
      
      {/* 스타일 설정 */}
      <StyleControl />
      
      <hr className="my-4" />
      
      {/* 클래스 추가 */}
      <Form.Group className="mb-3">
        <Form.Label>CSS 클래스 추가</Form.Label>
        <Form.Control
          type="text"
          value={className}
          onChange={(e) => handlePropsChange('className', e.target.value)}
          placeholder="custom-class another-class"
        />
        <Form.Text className="text-muted">
          여러 클래스는 공백으로 구분하여 입력하세요.
        </Form.Text>
      </Form.Group>
    </>
  );
};

export default SearchBarProperties;